import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import Icon from '../../../../Component/Layouts/App/Candidates/StudentApp/Icon';
import { STUDENT_BASE } from '../../../../Component/Layouts/App/Candidates/StudentApp/studentData';
import '../../../../Component/Layouts/App/Candidates/StudentApp/StudentLayout.css';

const Login = () => {
  const navigate = useNavigate();
  const [mobile, setMobile] = useState('');

  const continueIn = (event) => {
    event.preventDefault();
    if (mobile.trim().length < 10) return;
    navigate(STUDENT_BASE);
  };

  return (
    <div className="student-shell">
      <div className="student-app">
        <main className="student-main">
          <form className="sa-login" onSubmit={continueIn}>
            <div className="sa-logo">
              <Icon name="logo" />
              Focalyt
            </div>
            <h1 style={{ marginTop: 28 }}>Welcome back</h1>
            <p className="sa-mut" style={{ marginTop: 6, fontSize: 14, lineHeight: 1.5 }}>
              Sign in to continue your courses, jobs, clubs and achievements.
            </p>
            <label className="sa-label" htmlFor="student-mobile">Mobile number</label>
            <input
              id="student-mobile"
              className="sa-field"
              inputMode="numeric"
              autoComplete="tel"
              maxLength={10}
              placeholder="10-digit mobile number"
              value={mobile}
              onChange={(event) => setMobile(event.target.value.replace(/\D/g, '').slice(0, 10))}
            />
            <button type="submit" className="sa-btn block" disabled={mobile.length < 10}>
              Continue
            </button>
          </form>
        </main>
      </div>
    </div>
  );
};

export default Login;
